import { lazy } from 'react';
export var SupportChatPageAsync = lazy(function () { return import('./SupportChatPage'); });
